<template>
  <article class="usedcar_color">
    <h2 class="title">请选择车身颜色</h2>
    <div class="color_item">
      <ul>
        <li v-for="(item, index) in colorList" :key="index" @click.stop="selColor(item)">
          <a href="javascript:void(0);" :class="`class_bg_${item.id}`">{{item.name}}</a>
        </li>
        <li @click.stop="selColor({id: 21, name: '多彩色'})">
          <a href="javascript:void(0);" class="more_one">
            <span style="background-color: #1F7DD4;"></span>
            <span style="background-color: #B50109;"></span>
            <span style="background-color: #73A954;"></span>
            <span style="background-color: #D5B457;"></span>
          </a>
        </li>
      </ul>
    </div>
  </article>
</template>
<script>

export default {
  data() {
    return {
      colorList: [{
        id: 2,
        name: '白色'
      }, {
        id: 1,
        name: '黑色'
      }, {
        id: 4,
        name: '灰色'
      }, {
        id: 16,
        name: '绿色'
      }, {
        id: 3,
        name: '银色'
      }, {
        id: 15,
        name: '青色'
      }, {
        id: 20,
        name: '银灰色'
      }, {
        id: 8,
        name: '蓝色'
      }, {
        id: 19,
        name: '深灰色'
      }, {
        id: 14,
        name: '紫色'
      }, {
        id: 12,
        name: '米色'
      }, {
        id: 5,
        name: '红色'
      }, {
        id: 17,
        name: '香槟色'
      }, {
        id: 9,
        name: '栗色'
      }, {
        id: 10,
        name: '金色'
      }, {
        id: 7,
        name: '褐色'
      }, {
        id: 13,
        name: '黄色'
      }, {
        id: 18,
        name: '咖啡色'
      }, {
        id: 6,
        name: '棕色'
      }, {
        id: 11,
        name: '橙色'
      }]
    }
  },
  methods: {
    selColor(item) {
      let from = this.$route.query.from
      this.$router.push({
        path: from,
        query: {
          'colorInfo': {
            'id': item.id,
            'name': item.name
          }
        }
      })
    }
  }
}

</script>
<style scoped lang="less">
@import "../../stylesheets/modules/car/color.less";
</style>
